<template>
  <div class="pointer-events-auto">
    <div
      class="w-full bg-black z-10 fixed top-0 left-0 opacity-70 h-screen"
      :class="showMenu ? 'block md:hidden' : 'hidden'"
    ></div>
    <UiOnClickOutside :do="closeMenu">
      <nav
        class="container py-7.5 flex bg-white"
        :class="[
          showMenu
            ? 'w-[255px] md:w-full right-0 items-start absolute md:static z-[10000000000]'
            : 'w-full items-center',
        ]"
      >
        <div class="w-full px-5 md:px-7.5 lg:px-12.5">
          <div class="flex flex-col md:flex-row items-center">
            <div class="w-full flex md:w-auto md:static justify-between items-center">
              <div class="cursor-pointer" @click="logoToggle">
                <router-link to="/" class="gap-1.5 items-center flex">
                  <img class="h-8 w-8" :src="appLogo" />
                  <h5>MyQampus</h5>
                </router-link>
              </div>
              <div class="flex gap-3 sm:gap-4 items-center">
                <div v-if="!showMenu" class="flex md:hidden">
                  <ul>
                    <li @click="activeNavBarLink('signin')">
                      <button
                        class="bg-primary-purple-600 py-2.5 px-4.5 rounded-lg"
                        @click="redirectToSignup"
                      >
                        <nobr><h6 class="text-white">Sign up</h6></nobr>
                      </button>
                    </li>
                  </ul>
                </div>
                <input
                  id="openSidebarMenu"
                  type="checkbox"
                  class="h-11 w-13 sm:h-13 sm:w-17.5 md:h-16 md:w-20 xl:h-23 xl:w-28 small-screen-margin cursor-pointer pr-8 border border-solid border-transparent rounded bg-transparent block md:hidden outline-none focus:outline-none"
                  @click="toggleNavbar"
                />
                <label
                  for="openSidebarMenu"
                  class="sidebarIconToggle cursor-pointer top-[7px] w-7 md:w-12.5 right-0 md:right-7 md:hidden"
                >
                  <div class="spinner top" />
                  <div class="spinner middle" />
                  <div class="spinner bottom" />
                </label>
              </div>
            </div>
            <div
              :class="[showMenu ? 'flex' : 'hidden']"
              class="flex flex-col w-full md:w-3/4 h-screen md:h-auto xl:w-auto md:mt-0 md:ml-0 ml-auto -mt-px md:gap-4 xl:gap-7 md:flex md:flex-row md:flex-grow md:items-center"
            >
              <div class="my-5 md:m-0 md:order-1 flex justify-end cursor-pointer">
                <LanguageDropdown class="flex" :globe-color="globeColor" />
              </div>
              <div class="md:ml-0 md:w-full">
                <ul
                  class="flex flex-col gap-5 md:gap-4 xl:gap-8 md:justify-end justify-start md:flex-row list-none md:items-center"
                >
                  <h6 v-for="(link, index) in navbarLinks" :key="index">
                    <div @click="activeNavBarLink(link.activeNavBarLink)">
                      <router-link v-slot="{ isActive }" class="flex" :to="link.to">
                        <span
                          v-i18n="landingPage"
                          :class="[isActive && ' text-primary-purple-600']"
                        >
                          {{ link.name }}
                        </span>
                      </router-link>
                    </div>
                  </h6>
                </ul>
              </div>
              <div class="md:order-last mt-5 md:mt-0">
                <ul>
                  <li @click="activeNavBarLink('signin')">
                    <button
                      class="bg-primary-purple-600 py-2.5 px-4.5 rounded-lg"
                      @click="redirectToSignup"
                    >
                      <nobr><h6 class="text-white">Sign up</h6></nobr>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <div v-if="showMenu" class="md:hidden py-7.5 container mx-auto">
        <div class="flex items-center gap-1.5 px-5 md:px-7.5 lg:px-12.5">
          <img class="h-8 w-8" :src="appLogo" />
          <h5>MyQampus</h5>
        </div>
      </div>
    </UiOnClickOutside>
  </div>
</template>

<script>
import generalMixin from '@src/mixins/general-mixins.js'
import UiOnClickOutside from '@/src/components/misc/UiOnClickOutside.vue'
import LoginMixin from '@src/mixins/signin-mixins.js'
import LanguageDropdown from '@components/misc/LanguageDropdown.vue'

export default {
  name: 'Navbar',
  components: {
    UiOnClickOutside,
    LanguageDropdown,
  },
  mixins: [generalMixin, LoginMixin],
  props: {
    bgColor: { type: Boolean, default: false },

    removeBackground: {
      type: Boolean,
      default: false,
    },
    navbarLinks: {
      type: Array,
      default: () => [],
    },

    globeColor: {
      type: String,
      default: 'black',
    },
  },
  data() {
    return {
      showMenu: false,
      activeNavLink: 'home',
      landingPage: 'landingPage',
    }
  },
  computed: {
    appLogo() {
      return require(`@src/assets/images/app-logo.svg`)
    },
    navbarBg() {
      let response = this.showMenu ? 'mainBackground' : ''
      return response
    },
  },

  methods: {
    logoToggle() {
      if (this.showMenu) {
        this.showMenu = false
      }
      let sidebar = document.getElementById('openSidebarMenu')
      if (sidebar) sidebar.checked = false
      document.documentElement.style.overflowY = 'auto'
    },
    toggleNavbar: function () {
      this.showMenu = !this.showMenu
      this.$emit('showNavbar', this.showMenu)
      if (this.showMenu) {
        document.documentElement.style.overflow = 'hidden'
      } else {
        document.documentElement.style.overflowY = 'auto'
      }
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
    closeMenu: function () {
      this.showMenu = false
      document.documentElement.style.overflowY = 'auto'
      let sidebar = document.getElementById('openSidebarMenu')
      if (sidebar) sidebar.checked = false
    },
    activeNavBarLink(value) {
      document.documentElement.style.overflowY = 'auto'
      if (value) {
        this.activeNavLink = value
      }
      if (this.showMenu) {
        this.showMenu = false
      }
      let sidebar = document.getElementById('openSidebarMenu')
      if (sidebar) sidebar.checked = false
    },
    redirectToSignup() {
      this.$router.push({
        name: 'signup',
      })
    },
  },
}
</script>

<style lang="scss">
#openSidebarMenu:checked ~ #sidebarMenu {
  transform: translateX(0);
}

input#openSidebarMenu {
  display: none;
}

.sidebarIconToggle {
  transition: all 0.1s;
}

.spinner {
  width: 25px;
  height: 3px;
  background: var(--primary-gray-600);
  transition: all 0.1s;
}

.middle {
  margin: 5px 0;
}

#openSidebarMenu:checked ~ .sidebarIconToggle > .spinner.middle {
  opacity: 0;
}

#openSidebarMenu:checked ~ .sidebarIconToggle > .spinner.top {
  margin-top: 7px;
  transform: rotate(135deg);
}

#openSidebarMenu:checked ~ .sidebarIconToggle > .spinner.bottom {
  margin-top: -15.5px;
  transform: rotate(-135deg);
}

@media (min-width: 768px) {
  #openSidebarMenu:checked ~ .sidebarIconToggle > .spinner.top {
    transform: rotate(135deg);
  }
}
</style>
